export const companyCommand = {
  fortnoxConfig: 'fortnoxConfig',
  vismaConfig: 'vismaConfig',
  vismaControlEdgeConfig: 'vismaControlEdgeConfig',
  closeAccountingPeriod: 'closeAccountingPeriod',
  bulkSystemSettings: 'bulkSystemSettings',
};
